import { icon } from '@fortawesome/fontawesome-svg-core/import.macro';
import React from 'react';
import { Avatar } from 'src/components/Avatar';
import { Box } from 'src/components/Box';
import { Chip } from 'src/components/Chip';
import { Icon } from 'src/components/Icon';
import { Stack } from 'src/components/Stack';
import { Typography } from 'src/components/Typography';
import { SxProps } from 'src/components/muiTheme/utils';
import { Theme } from 'src/components/muiTheme/utils';
import { User } from 'src/models/user/_types';
import { getUserDisplayName, getUserInitials } from 'src/models/user/utils';

interface UserSelectorChipProps {
  user?: User;
  onChangeUser: () => void;
  size?: 'small' | 'medium';
  sx?: SxProps<Theme>;
  endAdornment?: React.ReactNode;
}

export const UserSelectorChip: React.FC<UserSelectorChipProps> = ({
  user,
  onChangeUser,
  size = 'medium',
  sx,
  endAdornment = (
    <>
      <Icon icon={icon({ name: 'pencil', style: 'regular' })} size="small" />
    </>
  ),
}) => {
  return (
    <Chip
      clickable
      onClick={onChangeUser}
      size={size}
      label={
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar
            src={user?.profileImage}
            initials={user ? getUserInitials(user) : ''}
            size={size === 'small' ? 'xsmall' : 'small'}
          />
          <Box>
            <Typography variant="body2" fontWeight={600}>
              {user ? getUserDisplayName(user) : 'Guest'}
            </Typography>
          </Box>
          {endAdornment}
        </Stack>
      }
      sx={{
        pl: 0.5,
        pr: 1,
        mb: 1,
        height: 'auto',
        py: 0.5,
        '& .MuiChip-label': {
          px: 0,
        },
        ...sx,
      }}
    />
  );
};
